"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectArrayResultPromise = exports.ObjectArrayPromise = exports.MaybeObjectResultPromise = exports.MaybeObjectPromise = exports.ValueArrayResultPromise = exports.ValueArrayPromise = void 0;
const promiseExecutor_1 = require("./promiseExecutor");
const maybe_1 = require("./maybe");
const lodash_1 = require("lodash");
const result_1 = require("./result");
/**
 * Represents a promise for an array of values - values as opposed to objects
 */
class ValueArrayPromise extends Promise {
    static build(promise) {
        return promiseExecutor_1.extendedPromise(ValueArrayPromise, promise);
    }
    count() {
        return this.then((values) => values.length);
    }
    first() {
        return maybe_1.MaybePromise.from(this.then((values) => maybe_1.Maybe.fromOptional(values[0])));
    }
    filter(fn) {
        return ObjectArrayPromise.build(this.then((values) => values.filter(fn)));
    }
    map(fn) {
        return ObjectArrayPromise.build(this.then((values) => values.map(fn)));
    }
}
exports.ValueArrayPromise = ValueArrayPromise;
/**
 * Represents a promise for a result containing an array of values - values as opposed to objects
 */
class ValueArrayResultPromise extends result_1.ResultPromise {
    static build(promise) {
        return promiseExecutor_1.extendedPromise(ValueArrayResultPromise, promise);
    }
    count() {
        return this.map((values) => values.length);
    }
    first() {
        return this.map((values) => maybe_1.Maybe.fromOptional(values[0]));
    }
    filterOk(fn) {
        return this.map((values) => values.filter(fn));
    }
    mapOk(fn) {
        return ObjectArrayResultPromise.build(this.map((values) => values.map(fn)));
    }
}
exports.ValueArrayResultPromise = ValueArrayResultPromise;
/**
 * Represents a promise for maybe having an object
 */
class MaybeObjectPromise extends maybe_1.MaybePromise {
    static build(promise) {
        return promiseExecutor_1.extendedPromise(MaybeObjectPromise, promise);
    }
    field(field) {
        return maybe_1.MaybePromise.from(this.then((maybeObj) => maybeObj.map((obj) => obj[field])));
    }
    pick(...fields) {
        return maybe_1.MaybePromise.from(this.then((maybeObj) => maybeObj.map((obj) => lodash_1.pick(obj, ...fields))));
    }
    omit(...fields) {
        return maybe_1.MaybePromise.from(this.then((maybeObj) => maybeObj.map((obj) => lodash_1.omit(obj, ...fields))));
    }
}
exports.MaybeObjectPromise = MaybeObjectPromise;
/**
 * Represents a promise for a result containing an array of values - values as opposed to objects
 */
class MaybeObjectResultPromise extends result_1.ResultPromise {
    static build(promise) {
        return promiseExecutor_1.extendedPromise(MaybeObjectResultPromise, promise);
    }
    field(field) {
        return this.map((maybeObj) => maybeObj.map((obj) => obj[field]));
    }
    pick(...fields) {
        return this.map((maybeObj) => maybeObj.map((obj) => lodash_1.pick(obj, ...fields)));
    }
    omit(...fields) {
        return this.map((maybeObj) => maybeObj.map((obj) => lodash_1.omit(obj, ...fields)));
    }
}
exports.MaybeObjectResultPromise = MaybeObjectResultPromise;
/**
 * Represents a promise for an array of objects
 */
class ObjectArrayPromise extends ValueArrayPromise {
    static build(promise) {
        return promiseExecutor_1.extendedPromise(ObjectArrayPromise, promise);
    }
    first() {
        return MaybeObjectPromise.build(this.then((rows) => maybe_1.Maybe.fromOptional(rows[0])));
    }
    field(field) {
        return ValueArrayPromise.build(this.then((rows) => rows.map((item) => item[field])));
    }
    pick(...fields) {
        return this.map((row) => lodash_1.pick(row, ...fields));
    }
    omit(...fields) {
        return this.map((row) => lodash_1.omit(row, ...fields));
    }
}
exports.ObjectArrayPromise = ObjectArrayPromise;
/**
 * Represents a promise for a result containing an array of values - values as opposed to objects
 */
class ObjectArrayResultPromise extends ValueArrayResultPromise {
    static build(promise) {
        return promiseExecutor_1.extendedPromise(ObjectArrayResultPromise, promise);
    }
    first() {
        return MaybeObjectResultPromise.build(this.map((rows) => maybe_1.Maybe.fromOptional(rows[0])));
    }
    field(field) {
        return ValueArrayResultPromise.build(this.mapOk((row) => row[field]));
    }
    pick(...fields) {
        return this.mapOk((row) => lodash_1.pick(row, ...fields));
    }
    omit(...fields) {
        return this.mapOk((row) => lodash_1.omit(row, ...fields));
    }
}
exports.ObjectArrayResultPromise = ObjectArrayResultPromise;
//# sourceMappingURL=promises.js.map